// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { controlVersion } from './version';

export const environment = {
  production: false,
  api: {
    identidade: 'https://identidade.comunidadeapp.com.br/api/identidade/',
    // identidade: 'http://192.168.18.238:49897/api/identidade/',
    backend: 'https://api.comunidadeapp.com.br/api/',
    // backend: 'http://192.168.18.238:52264/api/' // testar na maquina do rafa
  },
  uploads: 'https://condominioappstorage.blob.core.windows.net/condominioapp/Uploads/',
  apiUploads: 'https://condominioappstorageapi.azurewebsites.net/api/',
  apiSite: 'https://condominioappbackendsite.azurewebsites.net/api/',
  apiAdms: 'https://administradoras.azurewebsites.net/api/',
  api_cep: 'https://viacep.com.br/ws/',
  version: controlVersion.version,
  loginRedirect: {
    login: 'sindico@condominioapp.com',
    senha: '123456'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
